import { render, staticRenderFns } from "./LiefengUploadAudio.vue?vue&type=template&id=5e4aa202&scoped=true&"
import script from "./LiefengUploadAudio.vue?vue&type=script&lang=js&"
export * from "./LiefengUploadAudio.vue?vue&type=script&lang=js&"
import style0 from "./LiefengUploadAudio.vue?vue&type=style&index=0&id=5e4aa202&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4aa202",
  null
  
)

export default component.exports